import { appHistory } from '@wolffun/app-manager';
import { RouteName } from 'src/routes/config';
import { convertToUrl } from 'src/Pages/DashboardV2/utils';
import { CreatorCornerTab } from 'src/models';
export let MenuItem;

(function (MenuItem) {
  MenuItem["REFERRAL_PROGRAM"] = "referral_program";
  MenuItem["INVENTORY"] = "inventory";
  MenuItem["ACCOUNT_SETTINGS"] = "setting";
  MenuItem["HISTORY"] = "history";
  MenuItem["WALLET"] = "wallet";
  MenuItem["IN_GAME"] = "in_game";
  MenuItem["BATTLE_REWARDS"] = "battle_rewards";
  MenuItem["LOGOUT"] = "LOGOUT";
})(MenuItem || (MenuItem = {}));

export let CategoryKey;

(function (CategoryKey) {
  CategoryKey["TransactionHistory"] = "transaction-history";
  CategoryKey["BalanceHistory"] = "balance-history";
  CategoryKey["HeroHistory"] = "hero-history";
  CategoryKey["CosmeticHistory"] = "cosmetic-history";
  CategoryKey["BoxHistory"] = "box-history";
  CategoryKey["RentalHistory"] = "rental-history";
  CategoryKey["VestingSafeHistory"] = "vesting-safe-history";
})(CategoryKey || (CategoryKey = {}));

export let InventoryCategoryKey;

(function (InventoryCategoryKey) {
  InventoryCategoryKey["Heroes"] = "heroes";
  InventoryCategoryKey["Pets"] = "pets";
  InventoryCategoryKey["ThetaBox"] = "thetabox";
  InventoryCategoryKey["GiftBox"] = "giftbox";
  InventoryCategoryKey["Cosmetic"] = "cosmetic";
  InventoryCategoryKey["Others"] = "others";
})(InventoryCategoryKey || (InventoryCategoryKey = {}));

export let MoreItem;

(function (MoreItem) {
  MoreItem["CONVERSION_PROGRAM"] = "convert";
  MoreItem["VESTING_SAFE"] = "vesting";
  MoreItem["CREATOR_CORNER"] = "creator";
})(MoreItem || (MoreItem = {}));

const openNewTab = (path, search) => {
  if (search) {
    window.open(`${path}?${search}`, '_blank');
    return;
  }

  window.open(path, '_blank');
};

export const constructSearchQuery = params => {
  const {
    urlSearch,
    tab,
    category
  } = params;
  const searchQuery = new URLSearchParams(urlSearch); // we use UrlSearch for a default value because it's a normalized string

  if (tab) {
    searchQuery.set('tab', tab);
  }

  if (category) {
    searchQuery.set('category', category);
  }

  return searchQuery.toString();
};
export const navigateToHistoryPage = params => {
  const {
    urlSearch,
    tab,
    category
  } = params;
  const searchQuery = constructSearchQuery({
    urlSearch,
    tab,
    category
  });
  appHistory.history.push({
    pathname: RouteName.Profile,
    search: searchQuery
  });
};
export const navigateToHome = () => {
  appHistory.history.push({
    pathname: RouteName.HomeDashboard
  });
};
export const navigateToThetanBox = params => {
  const {
    isNewTab
  } = params || {};

  if (isNewTab) {
    openNewTab(RouteName.ThetanBox);
    return;
  }

  appHistory.history.push({
    pathname: RouteName.ThetanBox
  });
};
export const navigateToMarketplace = query => {
  appHistory.history.push({
    pathname: RouteName.MarketPlace,
    search: query
  });
};
export const navigateTradingEvent = () => {
  appHistory.history.push({
    pathname: RouteName.TradingEvent
  });
};
export const navigateToProfile = (tab, params, category) => {
  const {
    isNewTab
  } = params || {};
  const searchQuery = constructSearchQuery({
    tab,
    category
  });

  if (isNewTab) {
    openNewTab(RouteName.Profile, searchQuery);
    return;
  }

  appHistory.history.push({
    pathname: RouteName.Profile,
    search: searchQuery
  });
};
export const navigateToCreatorCorner = (tab = CreatorCornerTab.Creator) => {
  appHistory.history.push(`${RouteName.CreatorCorner}/${tab}`);
};
export const navigateToConnectWallet = ({
  backTo,
  redirectTo,
  isNewTab
}) => {
  if (isNewTab) {
    openNewTab(RouteName.Login);
    return;
  }

  appHistory.history.push({
    pathname: RouteName.Login,
    state: {
      redirectTo,
      backTo
    }
  });
};
export const navigateToMarketPlacePage = params => {
  const query = new URLSearchParams({
    tab: params.tab
  });
  appHistory.history.push({
    pathname: RouteName.MarketPlace,
    search: query.toString()
  });
};
export const navigateToLeaderboard = urlSearch => {
  appHistory.history.push({
    pathname: RouteName.LeaderBoard,
    search: urlSearch
  });
};
export const navigateToRental = () => {
  appHistory.history.push({
    pathname: RouteName.Rental
  });
};
export const navigateToConvertEvent = () => {
  appHistory.history.push({
    pathname: RouteName.ConvertEvent
  });
};
export const navigateToStaking = () => {
  appHistory.history.push({
    pathname: RouteName.Staking
  });
};
export const navigateToDailyQuest = param => {
  const {
    isNewTab,
    section
  } = param || {};

  if (isNewTab) {
    openNewTab(RouteName.DailyQuest + (section ? section : ''));
    return;
  }

  appHistory.history.push({
    pathname: RouteName.DailyQuest + (section ? section : '')
  });
};
export const navigateToBuyBoxDetail = boxName => {
  appHistory.history.push({
    pathname: `${RouteName.BuyThetanBox}/${convertToUrl(boxName)}`
  });
};
export const navigateToGiftBoxDetail = boxName => {
  appHistory.history.push({
    pathname: `${RouteName.GiftBox}/${convertToUrl(boxName)}`
  });
};
export const navigateToBundleBoxDetail = boxName => {
  appHistory.history.push({
    pathname: `${RouteName.BundleBox}/${convertToUrl(boxName)}`
  });
};
export const navigateToOpenGiftBoxDetail = boxName => {
  appHistory.history.push({
    pathname: `${RouteName.OpenGiftBox}/${convertToUrl(boxName)}`
  });
};
export const navigateToOpenBoxDetail = boxName => {
  appHistory.history.push({
    pathname: `${RouteName.OpenThetanBox}/${convertToUrl(boxName)}`
  });
};
export const navigateToInventoryPage = category => {
  const query = constructSearchQuery({
    category,
    tab: MenuItem.INVENTORY
  });
  appHistory.history.push(`${RouteName.Profile}?${query}`);
};
export const navigateToPrivateSaleCheckoutPage = (id, isAgreed) => {
  appHistory.history.push({
    pathname: `${RouteName.ProjectDetail}/${id}/buy`,
    state: {
      isAgreed
    }
  });
};
export const navigateToProjectDetail = id => {
  appHistory.history.push({
    pathname: `${RouteName.ProjectDetail}/${id}`
  });
};
export const navigateToInGamePage = params => {
  const {
    urlSearch,
    category
  } = params;
  const searchQuery = constructSearchQuery({
    urlSearch,
    tab: MenuItem.IN_GAME,
    category
  });
  appHistory.history.push({
    pathname: RouteName.Profile,
    search: searchQuery
  });
};
export const navigateToVestingSafe = () => {
  appHistory.history.push({
    pathname: RouteName.VestingSafe
  });
};
export const navigateToMinigame = () => {
  appHistory.history.push({
    pathname: RouteName.MiniGame
  });
};
export const navigateToSpecialEvent = () => {
  appHistory.history.push({
    pathname: RouteName.SpecialEvent
  });
};
export const navigateToTournament = () => {
  appHistory.history.push({
    pathname: RouteName.LeaderBoard
  });
};
export const navigateToTournamentInfo = () => {
  appHistory.history.push({
    pathname: RouteName.SpecialEventInfo
  });
};
export const navigateToFusion = () => {
  appHistory.history.push({
    pathname: RouteName.HeroFusion
  });
};
export const navigateToGiftmasFortuneWheel = () => {
  appHistory.history.push({
    pathname: RouteName.GiftmasFortuneWheel
  });
};
export const navigateToHeroDetail = (id, state) => {
  appHistory.history.push({
    pathname: `${RouteName.HeroDetail}/${id}`,
    state: state
  });
};
export const navigateToCosmeticDetail = (id, state) => {
  appHistory.history.push({
    pathname: `${RouteName.CosmeticDetail}/${id}`,
    state: state
  });
};
export const navigateToCoinbaseLootEvent = () => {
  appHistory.history.push({
    pathname: RouteName.CoinbaseLoot
  });
};